import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {TableHeaderService} from '../../../resources/services/table-header.service';
import {FormService} from '../../../resources/services/form.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {Location} from '@angular/common';
import {ProductService} from '../../../resources/services/product.service';
import {finalize} from 'rxjs/operators';
import {ActionService} from '../../../resources/services/action.service';
import {DeleteService} from '../../../resources/services/delete.service';

@Component({
  selector: 'product-edit',
  templateUrl: './product-edit.component.html',
})
export class ProductEditComponent implements OnInit {
  item: any;

  id: any = this._route.parent.snapshot.params.id;
  initial: string;
  formGroup: FormGroup;

  constructor(private tableHeaderService: TableHeaderService,
              private _formService: FormService,
              private _route: ActivatedRoute,
              private _toastr: ToastrService,
              private _location: Location,
              private _router: Router,
              private _modelService: ProductService,
              private deleteService: DeleteService) {
  }

  ngOnInit(): void {
    this.get();
  }

  get(): void {
    this._modelService.get({
      id: this.id,
      relations: ['parentStore', 'project', 'storeCollection']
    })
      .subscribe((res: any) => {
          this.item = res;
          this.initial = this.item.name;
        },
        err => {
        }
      );
  }

  delete(item) {
    this._router.navigate(['../../../'], {relativeTo: this._route});

    this.deleteService.process(item.type, item.name).then(() => {
      this._modelService.delete(this.id).subscribe();
    });
  }

  onSubmit(form) {
    setTimeout(() => {
      form.disable();
    });
    ;
    this._modelService.update(Object.assign({id: this.id}, form.value)).pipe(
      finalize(() => {
        this._router.navigate(['../../../'], {relativeTo: this._route});
      })
    ).subscribe();
  }

  back(e?: any) {
    if (e) {
      e.preventDefault();
    }

    this._location.back();
  }

}
